import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { LoadingScreen } from "../screens/LoadingScreen";
import uuid from "react-native-uuid";
import { Storage } from "../helpers/storage";
import { errorReporting } from "../helpers/errorReporting";

const DeviceContext = createContext<{
  deviceId: string;
}>(null!);

export const DeviceProvider = (props: PropsWithChildren) => {
  const [deviceId, setDeviceId] = useState<string>();

  useEffect(() => {
    const initDeviceId = async () => {
      const stored = await Storage.getItem("deviceId");
      const id = stored ?? (uuid.v4() as string);
      const saved = await Storage.setItem("deviceId", id);
      if (!saved) {
        errorReporting.sendMessage("Failed to persist deviceId to storage", {
          deviceId: id,
        });
      }
      setDeviceId(id);
      errorReporting.setDeviceId(id);
    };
    initDeviceId();
  }, []);

  if (deviceId == null) {
    return <LoadingScreen message="Setting device id" />;
  }

  return <DeviceContext.Provider value={{ deviceId }} {...props} />;
};

export const useDeviceId = () => {
  const ctx = useContext(DeviceContext);
  if (ctx == null) {
    throw new Error("useDeviceId: context not ready");
  }

  return ctx.deviceId;
};
